import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";
 
const teamAPI = createApi({
    reducerPath: "TeamAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getTeamList: builder.mutation({
            query: (teamQuery) => ({
                url: '/Teams/GetTeamList',
                method: 'POST',
                body: transformRequest(teamQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
         
        addEditTeam: builder.mutation({
            query: (Details) => ({
                url: '/Teams/AddEditTeams',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getTeamById: builder.query({
            query: (teamId) => ({
                url: encryptQueryString(`/Teams/GetTeamsById/?teamId=${Number(teamId)}`),
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        
        deleteTeam: builder.mutation({
            query: (id) => ({
                url: `/Teams/DeleteTeamsById/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getUserList: builder.query({
            query: () => ({
                url: `/User/GetAllUser`,
                method: 'GET',
            }),
           transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getTaskByUserIdAndTeamId: builder.mutation({
            query: (Details) => ({
                url: '/Teams/GetTaskByUserIdAndTeamId',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
})

export const {useGetTeamListMutation,useAddEditTeamMutation,useLazyGetTeamByIdQuery,useDeleteTeamMutation,useLazyGetUserListQuery,
    useGetTaskByUserIdAndTeamIdMutation
}=teamAPI;
export default teamAPI;